import React, { useEffect, useState } from "react";
import { Form, Container, Row, Col, Card } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { getPlace } from "../../store/slices/place";
import { gettravelHotel } from "../../store/slices/travelhotel";
import { getroomType } from "../../store/slices/roomtype";
import { toast } from "react-toastify";
import Select from "react-select";

export default function EditQuotationHotelStep({
  packageId,
  hotels,
  setHotels,
  nextStep,
  prevStep,
}) {
  const dispatch = useDispatch();

  const [roomTypesMap, setRoomTypesMap] = useState({});
  const [hotelsMap, setHotelsMap] = useState({});
  const [places, setPlaces] = useState([]);

  const [errors, setErrors] = useState([]);



useEffect(() => {

  const fetchPlaces =
    async () => {

      try {

        const placeRes =
          await dispatch(
            getPlace()
          ).unwrap();

        setPlaces(
          placeRes?.places ||
          placeRes?.data ||
          []
        );

      } catch (err) {

        toast.error(
          "Failed to load places"
        );

      }
    };

  fetchPlaces();

}, [dispatch]);

  useEffect(() => {
    const loadEditHotels = async () => {
      for (let i = 0; i < hotels.length; i++) {
        const config = hotels[i];

        if (config.place) {
          const hotelRes = await dispatch(
            gettravelHotel({ location: config.place?._id || config.place }),
          ).unwrap();

          setHotelsMap((prev) => ({
            ...prev,
            [config._id]: hotelRes?.hotels || [],
          }));
        }

        if (config.hotel) {
          const roomRes = await dispatch(
            getroomType({ hotelId: config.hotel?._id || config.hotel }),
          ).unwrap();

          setRoomTypesMap((prev) => ({
            ...prev,
            [config._id]: roomRes?.rooms || [],
          }));
        }
      }
    };

    if (hotels.length > 0) {
      loadEditHotels();
    }
  }, [hotels.length]);



  const handleChange = async (index, field, value) => {
    const updated = [...hotels];
    const newErrors = [...errors];

    if (!newErrors[index]) newErrors[index] = {};

    if (field === "place") {
      updated[index].place = value;
      updated[index].hotel = "";
      updated[index].roomType = "";

      setRoomTypesMap((prev) => ({
        ...prev,
     [updated[index]._id]: [],
      }));

      if (value) {
        try {
          const hotelRes = await dispatch(
            gettravelHotel({ location: value }),
          ).unwrap();

          setHotelsMap((prev) => ({
            ...prev,
[updated[index]._id]: hotelRes?.hotels || [],   
          }));
        } catch (err) {
          toast.error("Failed to load hotels");
        }
      }

      setHotels(updated);
      return;
    }
    if (field === "place") {
      if (!value) {
        newErrors[index].place = "Please select place";
      } else {
        newErrors[index].place = "";
      }
    }

    if (field === "hotel") {
      if (!value) {
        newErrors[index].hotel = "Please select hotel";
      } else {
        newErrors[index].hotel = "";
      }
    }

    if (field === "roomType") {
      if (!value) {
        newErrors[index].roomType = "Please select room type";
      } else {
        newErrors[index].roomType = "";
      }
    }

    updated[index][field] = value;

    if (field === "roomType" && value) {

  const selectedRoom =
    (roomTypesMap[
      updated[index]._id
    ] || []).find(
      (rt) =>
        String(rt._id) ===
        String(value)
    );

  if (selectedRoom) {

    updated[index].roomPrice =
      selectedRoom.basePrice || 0;

    updated[index].extraBedPrice =
      selectedRoom.extraBedPrice || 0;

    updated[index].childwithBedPrice =
      selectedRoom.childwithBedPrice || 0;

    updated[index].maxOccupancy =
      selectedRoom.maxOccupancy || 2;

    updated[index].maxExtraBeds =
      selectedRoom.maxExtraBeds || 0;

    updated[index].extraBedAllowed =
      selectedRoom.extraBedAllowed || false;

    updated[index].mealPrice = {
      breakfast:
        selectedRoom.meals
          ?.breakfast?.price || 0,

      lunch:
        selectedRoom.meals
          ?.lunch?.price || 0,

      dinner:
        selectedRoom.meals
          ?.dinner?.price || 0,
    };
  }
}
if (field === "roomPrice") {

  if (!value) {

    newErrors[index].roomPrice =
      "Please enter hotel price";

  } else if (!/^\d+$/.test(value)) {

    newErrors[index].roomPrice =
      "Only numbers allowed";

    return;

  } else if (
    String(value).length > 6
  ) {

    newErrors[index].roomPrice =
      "Maximum 6 digits allowed";

    return;

  } else {

    newErrors[index].roomPrice =
      "";
  }
}


    setHotels(updated);
    setErrors(newErrors);

    if (field === "hotel" && value) {
      try {
        const roomRes = await dispatch(
          getroomType({ hotelId: value }),
        ).unwrap();

        setRoomTypesMap((prev) => ({
          ...prev,
      [updated[index]._id]: roomRes?.rooms || [],
        }));
      } catch (err) {
        toast.error("Failed to load room types");
      }
    }
  };

  const validateHotelSubmit = () => {
    let isValid = true;

    const newErrors = hotels.map((config) => {
      const errorObj = {};

      if (!config.place) {
        errorObj.place = "Please select place";
        isValid = false;
      }

      if (config.hotel && !config.roomType) {
        errorObj.roomType = "Please select room type";
        isValid = false;
      }

    if (
  !config.roomPrice ||
  Number(config.roomPrice) <= 0
) {

  errorObj.roomPrice =
    "Hotel price is required";

  isValid = false;
}
      return errorObj;
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleMealChange = (index, meal) => {
    const updated = [...hotels];
    const updatedErrors = [...errors];

    if (!updatedErrors[index]) updatedErrors[index] = {};

    updated[index] = {
      ...updated[index],
      meals: {
        ...updated[index].meals,
        [meal]: !updated[index].meals?.[meal],
      },
    };

    const { breakfast, lunch, dinner } = updated[index].meals;

    if (!breakfast && !lunch && !dinner) {
      updatedErrors[index].meals = "Please select at least one meal";
    } else {
      updatedErrors[index].meals = "";
    }

    setHotels(updated);
    setErrors(updatedErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    //  Check if user selected ANY hotel
    const hasAnyHotelSelected = hotels.some((h) => h.hotel);

    //  Only validate if at least one hotel is selected
    if (hasAnyHotelSelected && !validateHotelSubmit()) return;

    try {
      //  Only save configs where hotel is selected
      
      //  Always allow next step
      nextStep();
    } catch (err) {
      toast.error("Failed to save hotels");
    }
  };


const hotelsByOption =
  Object.values(
    hotels.reduce(
      (acc, hotel) => {

        const optionId =
          hotel.packageOption;

        if (!acc[optionId]) {

          acc[optionId] = {
            option: {
              _id: optionId,

             name: hotel?.packageOptionDetails ?.name || hotel?.packageOptionName || `Option ${ Object.keys(acc) .length + 1 }`,
            },

            configs: [],
          };
        }

        acc[optionId].configs.push(
          hotel
        );

        return acc;

      },
      {}
    )
  );


  return (
    <Container>
      <Card className="p-4 shadow-sm border-0 mt-2">
        <Row>
          {hotelsByOption.map(({ option, configs }) => (
            <Col md={6} key={option._id}>
              <Card className="p-3 mb-3 shadow-sm">
                <h5 className="text-center mb-3">{option.name}</h5>

        
{configs.map(
  (config, configIndex) => {

const index =
  hotels.findIndex(
    (h) =>
      String(h._id) ===
      String(config._id)
  );

const mapKey =
  config._id || index;

return (

                    <Card key={index} className="mb-3 p-3 border">
                    
<h6>
  Day {configIndex + 1}
</h6>


                      <Row className="g-3">
                        {/* Place */}
                        <Col md={6}>
                          <Form.Label>Place</Form.Label>
                         <Select
  placeholder="Select Place"
  value={
    places
      .map((p) => ({
        value: p._id,
        label: p.name,
      }))
      .find( (o) => String(o.value) === String( config.place?._id || config.place ) ) || null
  }
  onChange={(selected) =>
    handleChange(index, "place", selected?.value || "")
  }
  options={places.map((p) => ({
    value: p._id,
    label: p.name,
  }))}
/>
                        </Col>

                        {/* Hotel */}
                        <Col md={6}>
                          <Form.Label>Hotel</Form.Label>
                         <Select
  placeholder="Select Hotel"
  isDisabled={!config.place}
  value={
  (hotelsMap[mapKey] || [])
      .map((h) => ({
        value: h._id,
        label: h.name,
      }))
     .find( (o) => String(o.value) === String( config.hotel?._id || config.hotel ) ) || null
  }
  onChange={(selected) =>
    handleChange(index, "hotel", selected?.value || "")
  }
  options={(hotelsMap[mapKey] || []).map((h) => ({
    value: h._id,
    label: h.name,
  }))}
/>
                        </Col>

                        {/* Room Type */}
                        <Col md={6}>
                          <Form.Label>Room Type</Form.Label>
                          <Form.Select
                           value={ config.roomType?._id || config.roomType || "" }
                            disabled={!config.hotel}
                            onChange={(e) =>
                              handleChange(index, "roomType", e.target.value)
                            }
                          >
                            <option value="">Select Room</option>
                            {(roomTypesMap[mapKey] || []).map((rt) => (
                              <option key={rt._id} value={rt._id}>
                                {rt.name} (₹{rt?.basePrice})
                              </option>
                            ))}
                          </Form.Select>
                        </Col>

<Col md={6}>
  <Form.Label>
    Hotel Price
  </Form.Label>

 <Form.Control
  type="text"
  inputMode="numeric"
  maxLength={6}
  value={config.roomPrice || ""}
  onChange={(e) => {

    const value =
      e.target.value.replace(
        /\D/g,
        ""
      );

    handleChange(
      index,
      "roomPrice",
      value
    );
  }}
/>
{errors[index]?.roomPrice && (
  <div
    style={{
      color: "red",
      fontSize: "12px",
    }}
  >
    {
      errors[index]
        .roomPrice
    }
  </div>
)}
</Col>

                        {/* Nights */}
                     
                        {/* Meals */}
                        <Col md={6}>
                          <Form.Label>Meals</Form.Label>

                          <div className="d-flex gap-3">
                            <Form.Check
                              type="checkbox"
                              label="Breakfast"
                              checked={config.meals?.breakfast || false}
                              onChange={() =>
                                handleMealChange(index, "breakfast")
                              }
                            />

                            <Form.Check
                              type="checkbox"
                              label="Lunch"
                              checked={config.meals?.lunch || false}
                              onChange={() => handleMealChange(index, "lunch")}
                            />

                            <Form.Check
                              type="checkbox"
                              label="Dinner"
                              checked={config.meals?.dinner || false}
                              onChange={() => handleMealChange(index, "dinner")}
                            />
                          </div>

                          {errors[index]?.meals && (
                            <div style={{ color: "red", fontSize: "12px" }}>
                              {errors[index].meals}
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Card>
                  );
                })}
              </Card>
            </Col>
          ))}
        </Row>

        <div className="d-flex justify-content-between mt-4 mb-5">
          <button className="cancel-btn" onClick={prevStep}>
            Previous
          </button>
        

          <button className="submit-btn" onClick={handleSubmit}>
            Next
          </button>
        </div>
      </Card>
    </Container>
  );
}
